import type { IDisposable } from '@/engine/Utilities/IDisposable';
import type * as ImageStackTypes from '../../../../WasmModules/ImageStack';
import * as THREE from 'three';
import { ImageSlice } from './ImageSlice';
import type { ImageSliceCanvasRenderingContext } from './ImageSliceCanvasRenderingContext';

export class ImageStackSlicer implements IDisposable {
  private readonly _wrapped: ImageStackTypes.ImageStackSlicer;

  private readonly _sliceThickness: number;

  private readonly _slicesCount: number;

  private readonly _sliceReductionFactor: number;

  private readonly _size: THREE.Vector3;

  private readonly _spacings: THREE.Vector3;

  private readonly _volumeCS: THREE.Matrix4;

  private readonly _volumeOrientation: Array<string>;

  public constructor(toWrap: ImageStackTypes.ImageStackSlicer) {
    this._wrapped = toWrap;
    this._sliceThickness = this._wrapped.getSliceThickness();
    this._slicesCount = this._wrapped.getSlicesCount();
    this._sliceReductionFactor = this._wrapped.getSliceReductionFactor();
    this._size = new THREE.Vector3().fromArray(this._wrapped.getSize());
    this._spacings = new THREE.Vector3().fromArray(this._wrapped.getSpacings());
    this._volumeCS = new THREE.Matrix4().fromArray(this._wrapped.getVolumeCS());
    this._volumeOrientation = Array.from(this._wrapped.getVolumeOrientation());
  }

  public dispose(): void {
    this._wrapped.dispose();
  }

  // ------------------ Wrapped methods -------------------------

  public getSliceThickness(): number {
    return this._sliceThickness;
  }

  public getSlicesCount(): number {
    return this._slicesCount;
  }

  public getSize(): THREE.Vector3 {
    return this._size;
  }

  public getSpacings(): THREE.Vector3 {
    return this._spacings;
  }

  public getVolumeCS(): THREE.Matrix4 {
    return this._volumeCS;
  }

  public getVolumeOrientation(): Array<string> {
    return this._volumeOrientation;
  }

  public getSliceReductionFactor(): number {
    return this._sliceReductionFactor;
  }

  public getSliceByIndex(index: number): ImageSlice {
    return new ImageSlice(this._wrapped.getSliceByIndex(index));
  }

  public getSliceByCoplanarPoint(pt: THREE.Vector3): ImageSlice {
    return new ImageSlice(this._wrapped.getSliceByCoplanarPoint(pt.x, pt.y, pt.z));
  }

  public initializeSliceRenderingContext(context: ImageSliceCanvasRenderingContext): void {
    context.init(this._size.x, this._size.y);
  }
}
